.select {
  appearance: none;
  text-overflow: ellipsis;
  font: inherit;
  width: 100%;

  &:hover:not(:disabled):not(.select--readonly) {
    border-color: var(--dds-color-border-action-hover);
    box-shadow: 0 0 0 1px var(--dds-color-border-action-hover);

    & + svg {
      color: var(--dds-color-icon-action-hover);
    }
  }
  &:disabled {
    opacity: 1;
    cursor: not-allowed;
    color: var(--dds-color-text-subtle);
    background-color: var(--dds-color-surface-field-disabled);
    border-color: var(--dds-color-border-subtle);

    + svg {
      color: var(--dds-color-icon-subtle);
    }
  }
  option {
    background-color: var(--dds-color-surface-default);
    &:hover {
      background-color: var(--dds-color-surface-hover-default);
    }
    @media (prefers-reduced-motion: no-preference) {
      transition: background-color var(--dds-motion-micro-state);
    }
  }
  optgroup {
    font-weight: normal;
    font-style: normal;
  }
}

.select--readonly {
  box-shadow: none;
  outline: none;
  cursor: default;
  color: var(--dds-color-text-subtle);
  background-color: var(--dds-color-surface-field-disabled);

  + svg {
    color: var(--dds-color-icon-subtle);
  }
}

.select--multiple {
  padding-right: 0;

  &.select--readonly option {
    background-color: var(--dds-color-surface-field-disabled);
  }
}
